<template>
  <base-modal
    id="guest-list"
    ref="guest-list"
    size="modal-md"
    :show="show"
    :show-close-button="true"
    @closed="modalClosed"
  >
    <div>
      {{ modalType }}
    </div>
  </base-modal>
</template>
<script>

export default {
  name: 'GuestListModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    modalType: {
      type: String,
      default: '',
    },
  },
  methods: {
    modalClosed() {
      this.$emit('close-modal');
    },
  },
};

</script>
